export default __webpack_public_path__ + "static/selfapp-736-16a0f2e52a0d30cb1e4db742fa6a0773.jpg";